import script from "./Triggers.vue?vue&type=script&lang=ts&setup=true"
export * from "./Triggers.vue?vue&type=script&lang=ts&setup=true"

import "./Triggers.vue?vue&type=style&index=0&id=016f94dc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016f94dc"]])

export default __exports__